<ng-template #toolEditButtonTemplate let-idvaluechild="idvalue">
  <div class="row justify-content-center">
    <button class="btn btn-action" (click)="editUserTools(idvaluechild)" title="Edit tools"><i class="fa fa-tools"></i></button>
  </div>
</ng-template>

<app-crud-list [observabledata]="getObservableData()"
               [postTreatmentCallback]="getPostTreatmentCallback()"
               [listEditPathCallback]="getListEditPathCallback()"
               [displayedColumns]="displayedcolumns"
               [idColumnName]="'id'"
               [entityroot]="entityroot"
               [deleteEntityHandler]="deleteEntityHandler()"
               [removePostTreatmentHandler]="deletePostTreatmentHandler()"
               [specificColumnsTemplates]="[
                  {key: 'tool-edit-button', template: toolEditButtonTemplate}
               ]">
</app-crud-list>
